import type { ReactNode } from 'react';

import { FilterWidgetWrapper } from 'src/pages/dashboard/features/filter-widget/FilterWidget';
import type { FilterWidgetEntity } from 'src/pages/dashboard/features/filter-widget/FilterWidget.entity';

import type { TWidgetRendererOptions } from './WidgetRendererService';

export function renderWellsFilterWidget(widget: FilterWidgetEntity, options: TWidgetRendererOptions): () => ReactNode {
  return () => <FilterWidgetWrapper filterWidgetEntity={widget} options={options} />;
}
